import { Typography } from '@mui/material';

import { ErrorLoadingPage, Loading } from '@hapvida/hapvida-core-components';

import { AlertReport } from '@flows/private/financial/pages/Detail/components/AlertReport';
import { useAuth } from '@hooks';
import { UserType } from '@contexts';

import { AcceptedInfos, AcceptForm, ChangeHistory } from './components';
import { useResponsibilityLetter } from './hooks';

export function ResponsibilityLetterContent() {
  const {
    responsibilityLetterState,
    historyResponsibilityLetterState,
    refreshResponsibilityLetterStates,
  } = useResponsibilityLetter();

  const { user } = useAuth();

  const {
    isLoading: isLoadingResponsibilityLetter,
    isError: isErrorResponsibilityLetter,
    data: dataResponsibilityLetter,
  } = responsibilityLetterState;
  const {
    isLoading: isLoadingHistoryResponsibilityLetter,
    isError: isErrorHistoryResponsibilityLetter,
    data: dataHistoryResponsibilityLetter,
  } = historyResponsibilityLetterState;

  if (isLoadingResponsibilityLetter || isLoadingHistoryResponsibilityLetter) {
    return (
      <Loading
        message={
          <>
            Estamos carregando as informações. <br /> Em breve, tudo estará
            pronto para você
          </>
        }
      />
    );
  }

  if (isErrorResponsibilityLetter || isErrorHistoryResponsibilityLetter) {
    return (
      <ErrorLoadingPage onReloadClick={refreshResponsibilityLetterStates} />
    );
  }

  const { isResponsibilityLetterAccepted } = dataResponsibilityLetter;
  const isBackoffice = user?.companyType === UserType.Backoffice;

  return (
    <>
      {isResponsibilityLetterAccepted ? (
        <AcceptedInfos />
      ) : (
        <>
          {isBackoffice ? (
            <AlertReport severity="info">
              <Typography variant="text">
                Usuários backoffice não tem permissão para aceitar carta de
                responsabilidade.
              </Typography>
            </AlertReport>
          ) : (
            <AcceptForm />
          )}
        </>
      )}

      <ChangeHistory changeHistory={dataHistoryResponsibilityLetter} />
    </>
  );
}
